/**
 * @file Helpers for order-related URL parameters.
 */

import { getQueryParam } from "../browser/queryParams";

/**
 * Retrieves the order ID from the current URL's query parameters.
 *
 * @returns {string | null} The order ID if present in the URL, otherwise null.
 */
export const getOrderId = (): string | null => getQueryParam("order_id");

/**
 * Checks if the current page is the "Thank You" page based on whether an order ID in the URL.
 *
 * @returns {boolean} `true` if the order ID is present, indicating the "Thank You" page; otherwise, `false`.
 */
export const checkIsThankyouPage = (): boolean => !!getOrderId();
